import React from 'react';
import styled from 'styled-components';

//#region Styled Components
const StyledResults = styled.div`
  padding: 0;
  margin: 0 auto;
  padding-top: 9.25rem;
  width: 95%;
  min-height: 100vh;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
`;
//#endregion

const Results = ({ children }) => <StyledResults>{children}</StyledResults>;

export default Results;
